import { useState, useEffect } from 'react';
import { iconMap } from '../../../utils/getSeatIconUrl';
export const useGetSeatIcons = brandCode => {
  const [seatIcons, setSeatIcons] = useState({});
  useEffect(() => {
    const loadIcon = async (brand, key) => {
      try {
        const module = await import(`@eti/assets/icons/seating-buttons/${brand}/seatButton-${key}.svg`);
        return module.ReactComponent;
      } catch {
        return null;
      }
    };
    const loadAllIcons = async () => {
      const iconKeys = ['selected', ...Object.values(iconMap).filter(Boolean)];
      const loadedIcons = await Promise.all(iconKeys.map(async key => {
        var _await$loadIcon;
        const icon = (_await$loadIcon = await loadIcon(brandCode, key)) !== null && _await$loadIcon !== void 0 ? _await$loadIcon : await loadIcon('default', key);
        return [key, icon];
      }));
      setSeatIcons(Object.fromEntries(loadedIcons));
    };
    loadAllIcons();
  }, [brandCode]);
  return seatIcons;
};
//# sourceMappingURL=useGetSeatIcons.js.map